import axios from "axios"

const apiUrl = "/api/"

// --- HELPER-FUNKTIONEN ---

function buildUrl(path) {
  return `${apiUrl}${path}`
}

function buildOptions(options = {}) {
  if (!options.headers) {
    options.headers = {}
  }
  options.headers.Authorization = localStorage.getItem("token")
  return options
}

// --- API-DEFINITIONEN ---

export default {
  reservationTool: {
    fetchReservationAvailability() {
      let url = buildUrl("reservation-types/availability")
      return axios.get(url, buildOptions()).then((res) => res.data)
    },
    deleteReservationType(id) {
      return axios.delete(buildUrl(`reservation-types/${id}`), buildOptions())
    },
    getTimeslots(reservationTypeId, date) {
      const params = { date }
      return axios.get(buildUrl(`reservations/timeslots/${reservationTypeId}`), buildOptions({ params }))
    },
    getReservations(studioId) {
      return axios.get(buildUrl(`reservations/${studioId}`), buildOptions())
    },
    createReservation(data) {
      return axios.post(buildUrl("reservations"), data, buildOptions())
    },
    updateReservation(id, data) {
      return axios.put(buildUrl(`reservations/${id}`), data, buildOptions())
    },
    deleteReservation(id) {
      return axios.delete(buildUrl(`reservations/${id}`), buildOptions())
    },
    // Reservation Types
    getReservationTypes(studioId) {
      return axios.get(buildUrl(`reservation-types/${studioId}`), buildOptions())
    },
    getReservationTypesForAdmin() {
      return axios.get(buildUrl(`reservation-types/admin`), buildOptions())
    },
    createReservationType(data) {
      return axios.post(buildUrl("reservation-types"), data, buildOptions())
    },
    updateReservationType(id, data) {
      return axios.put(buildUrl(`reservation-types/${id}`), data, buildOptions())
    },
    reportDefective(id, data) {
      return axios.post(buildUrl(`reservation-types/${id}/report-defective`), data, buildOptions())
    },
    reactivateReservationType(id) {
      return axios.post(buildUrl(`reservation-types/${id}/reactivate`), {}, buildOptions())
    },
    getReservationTypeDetails(id) {
      return axios.get(buildUrl(`reservation-types/details/${id}`), buildOptions())
    },
    getMyReservations() {
      return axios.get(buildUrl(`reservations/my-reservations`), buildOptions())
    },
    getMyCalendarAppointments() {
      return axios.get(buildUrl("appointments/my"), buildOptions())
    },
    rateCalendarAppointment(appointmentId, data) {
      return axios.put(buildUrl(`appointments/my/${appointmentId}/rating`), data, buildOptions())
    },
    getReservationsForAdmin(params) {
      return axios.get(buildUrl(`reservations/admin/all`), buildOptions({ params }))
    },
  },
}
